// extracted by mini-css-extract-plugin
export var accordion = "_b6-0";
export var chevron = "_b6-3";
export var closed = "_b6-2";
export var content = "_b6-4";
export var open = "_b6-1";
export var rotate = "_b6-5";